import { gql, useQuery } from '@apollo/client';

const GET_AUDIT_DOCUMENT = gql`
  query GetAuditDocument($applicationId: String, $locale: String) {
    getAuditDocument(applicationId: $applicationId, locale: $locale) {
      id
      createdAt
      updatedAt
      document
      locale
    }
  }
`;

export interface GetAuditDocumentInput {
  applicationId?: string;
  locale?: string;
}

export interface AuditDocument {
  id: string;
  createdAt: string;
  updatedAt: string;
  document: string;
  locale: string;
}

export interface GetAuditDocumentResult {
  getAuditDocument: AuditDocument;
}

export function useGetAuditDocumentQuery(applicationId?: string, locale: string = 'de-DE') {
  return useQuery<GetAuditDocumentResult, GetAuditDocumentInput>(GET_AUDIT_DOCUMENT, {
    variables: { applicationId, locale },
    // pollInterval: 5000,
  });
}
